import React, { Component } from "react";
import {
  FlatButton,
  SelectField,
  MenuItem,
  label,
  Menu,
  TextField,
  Card,
  CardTitle,
  IconButton,
  AppBar,
} from "material-ui";
import {
  FormsyRadioGroup,
  FormsyRadio,
  FormsyText,
} from "formsy-material-ui/lib";
import Formsy from "formsy-react";
import Loading from "../Loading";
import Dropzone from "react-dropzone";
import { Link } from "react-router";
import ApiQueue from "../../../utils/api-queue";

import deleteDefaultIcon from "../../images/delete_default.png";
import editDefaultIcon from "../../images/edit_default.png";
import importDefaultIcon from "../../images/import_default.png";
import AddNewDocumentType from "./AddNewDocumentType";
import companyListIcon from "../../images/company_list.png";
import backIcon from "../../images/back.png";
import checkedIcon from "../../images/checked.png";
import addArrowIcon from "../../images/add_arrow.png";

import CreateMailingList from "./CreateMailingList";
import ShowMailingList from "./ShowMailingList";
import ShowPayrollCheck from "./ShowPayrollCheck";
import ShowCompanyDetail from "./ShowCompanyDetail";
import ShowUpload8879s from "./ShowUpload8879s";

class GenericUploader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      message: "Click to upload file, or drag and drop file",
      isLoading: false,
      value: "",
      companies: [],
      docUploader: [],
      mailingTypeList: [],
      mailingTypeUserList: [],
      showAddDocument: false,
      showDocTypeSelectBox: false,
      docValue: "other",
      isPageBreak: "yes",
      showMailingType: "SHOW_MAILING_LIST",
      mailingTypeData: {},
      data: "",
      companyEditData: {},
    };
    this.apiQueue = new ApiQueue(this.getSearchMessageCallback);
  }

  componentDidMount() {
    this.getAllDocUploader();
    this.getAllMailingType();
    this.getAllCompanies();
  }

  onSelectDocType = (value, docUploaderData) => {
    this.setState({ docValue: value });
    if (value == "payroll_check") {
      this.navigation({}, "SHOW_PAYROLL_CHECK", "");
    } else if (value == "8879") {
      this.navigation({}, "SHOW_8879", "");
    } else {
      this.navigation({}, "SHOW_MAILING_LIST", docUploaderData);
    }
  };

  getAllDocUploader = () => {
    let url = `/api/documentUpload/getDocUploader`;
    let options = {
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        this.setState({ isLoading: false, docUploader: json.docUploader });
      });
  };

  getAllMailingType = (data) => {
    if (data) {
      /*let url = `/api/documentUpload/getMailingTypeList?searchText=`+data;
            let options = {
                headers: {
                    token: this.props.token.jwt
                }
            }
            fetch(url, options)
            .then(res => {
                if(res.status >= 200 && res.status < 300) return res.json();
            })
            .then(json => {
                this.setState({isLoading: false,mailingTypeList: json.mailingTypeList});
            });*/
      this.getMessagesAccordingToSearch(data);
    } else {
      let url = `/api/documentUpload/getMailingTypeList`;
      let options = {
        headers: {
          token: this.props.token.jwt,
        },
      };
      fetch(url, options)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) return res.json();
        })
        .then((json) => {
          this.setState({
            isLoading: false,
            mailingTypeList: json.mailingTypeList,
          });
        });
    }
  };

  getMessagesAccordingToSearch = (searchText) => {
    let token = this.props.token.jwt;
    let body = {
      extraParameter: { searchText, token },
    };
    this.apiQueue.addOperation(body);
  };

  getSearchMessageCallback = (type, result, extraParameter) => {
    var me = this;
    if (type == "SUCCESS") {
      me.setState({ isLoading: false, mailingTypeList: result });
    }
  };

  getAllCompanies = (data) => {
    let url = `/api/payroll/getAllCompanies`;
    if (data) {
      url = `/api/payroll/getAllCompanies?searchText=` + data;
    }
    let options = {
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        this.setState({ isLoading: false, companies: json.companies });
      });
  };

  deleteMailingList = (row) => {
    var me = this;
    let url = `/api/documentUpload/deleteMailingType/${row._id}`;
    let options = {
      method: "delete",
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) {
          me.getAllMailingType();
        }
      })
      .then((json) => {
        this.setState({ isLoading: false });
      });
  };

  deleteCompany = (row) => {
    var me = this;
    let url = `/api/payroll/deleteCompany/${row._id}`;
    let options = {
      method: "delete",
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) {
          me.getAllCompanies();
        }
      })
      .then((json) => {
        this.setState({ isLoading: false });
      });
  };

  updateMailingList = (row) => {
    //this.setState({company: row, open: true});
  };

  handleClose = () => {
    this.setState({ showDocTypeSelectBox: false });
  };

  renderDocUploader = () => {
    let { docUploader, showDocTypeSelectBox } = this.state;
    return (
      <Menu open={showDocTypeSelectBox}>
        {docUploader && docUploader.length
          ? docUploader.map((docUploaderData, index) => {
              return (
                <MenuItem
                  onClick={this.handleClose}
                  value={index}
                  primaryText="Never"
                />
              );
            })
          : null}
      </Menu>
    );
  };

  navigation = (rowData, navValue, searchText) => {
    var me = this;
    if (navValue == "SHOW_MAILING_LIST") {
      if (typeof searchText === "string") {
        this.getAllMailingType(searchText);
      }
      this.setState({
        showMailingType: "SHOW_MAILING_LIST",
        mailingTypeData: rowData,
        data: searchText,
      });
    } else if (navValue == "CREATE_MAILING_LIST") {
      this.getAllMailingType("");
      this.state.mailingTypeList.map((mailingTypeObj) => {
        if (rowData._id == mailingTypeObj._id) {
          rowData = mailingTypeObj;
          this.getMailingTypeUserList(rowData);
        }
      });
      this.setState({
        showMailingType: "CREATE_MAILING_LIST",
        mailingTypeData: rowData,
      });
    } else if (navValue == "SHOW_8879") {
      this.setState({ showMailingType: "SHOW_8879" });
    } else if (navValue == "SHOW_COMPANY_DETAIL") {
      this.getAllCompanies();
      this.state.companies.map((companyObj) => {
        if (rowData.companyId == companyObj.companyId) {
          rowData = companyObj;
        }
      });
      if (searchText) {
        let employeeList = [];
        rowData.employees.map((compObj) => {
          if (
            compObj.name.toLowerCase().indexOf(searchText.toLowerCase()) > -1
          ) {
            employeeList.push(compObj);
          }
        });
        rowData.employees = employeeList;
      }
      this.setState({
        showMailingType: "SHOW_COMPANY_DETAIL",
        companyEditData: rowData,
      });
    } else if (
      navValue == "SHOW_PAYROLL_CHECK" ||
      this.state.docValue == "payroll_check"
    ) {
      this.getAllCompanies(searchText);
      this.setState({ showMailingType: "SHOW_PAYROLL_CHECK" });
    } else {
      this.getAllMailingType("");
    }
  };

  getMailingTypeUserList = (rowData) => {
    let url =
      `/api/documentUpload/getMailingTypeUserList?mailingTypeId=` + rowData._id;
    let options = {
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        this.setState({
          isLoading: false,
          mailingTypeUserList: json.mailingTypeUserList,
        });
      });
  };

  closeAddNewDocTypeModal = () => {
    this.setState({ showAddDocument: false });
    this.getAllDocUploader();
  };

  handleSelection = (event) => {
    this.setState({ isPageBreak: event.target.value });
  };

  render() {
    let { docUploader, showMailingType } = this.state;
    return (
      <div className="containerbody">
        <div className="companyContainer" style={{ padding: "0px 15px" }}>
          <div style={{ display: "flex" }}>
            <div style={{ display: "inline-block", width: "20%" }}>
              <SelectField
                floatingLabelText="Document Type"
                value={this.state.docValue}
                style={{ width: "95%" }}
              >
                {docUploader && docUploader.length
                  ? docUploader.map((docUploaderData, index) => {
                      return (
                        <MenuItem
                          onClick={() => {
                            this.onSelectDocType(
                              docUploaderData.kind,
                              docUploaderData,
                            );
                          }}
                          key={"docUploader_" + index}
                          value={docUploaderData.kind}
                          primaryText={docUploaderData.name}
                        />
                      );
                    })
                  : null}
              </SelectField>
            </div>
          </div>
          <br />
          <ShowMailingList
            mailingTypeList={this.state.mailingTypeList}
            open={showMailingType == "SHOW_MAILING_LIST" ? true : false}
            token={this.props.token.jwt}
            navigation={this.navigation}
            deleteMailingList={this.deleteMailingList}
            data={this.state.data}
            docValue={this.state.docValue}
            closeAddNewDocTypeModal={this.closeAddNewDocTypeModal}
          />
          <CreateMailingList
            mailingTypeUserList={this.state.mailingTypeUserList}
            open={showMailingType == "CREATE_MAILING_LIST" ? true : false}
            token={this.props.token.jwt}
            navigation={this.navigation}
            mailingType={this.state.mailingTypeData}
            snackbar={this.props.snackbar}
          />
          <ShowPayrollCheck
            open={showMailingType == "SHOW_PAYROLL_CHECK" ? true : false}
            token={this.props.token.jwt}
            companies={this.state.companies}
            navigation={this.navigation}
            deleteCompany={this.deleteCompany}
          />
          <ShowCompanyDetail
            open={showMailingType == "SHOW_COMPANY_DETAIL" ? true : false}
            token={this.props.token.jwt}
            snackbar={this.props.snackbar}
            companyData={this.state.companyEditData}
            navigation={this.navigation}
          />
          <ShowUpload8879s
            open={showMailingType == "SHOW_8879" ? true : false}
            token={this.props.token.jwt}
            navigation={this.navigation}
          />
        </div>
        <AddNewDocumentType
          open={this.state.showAddDocument}
          token={this.props.token}
          closeAddNewDocTypeModal={this.closeAddNewDocTypeModal}
        />
      </div>
    );
  }
}

export default GenericUploader;



// WEBPACK FOOTER //
// ./app/components/documentUploader/GenericUploader.js